<template>
  <div
    :style="{ width: containerSize ? `${containerSize}px` : null, height: containerSize ? `${containerSize}px` : null }"
    class="app-feather"
    :class="[{'app-feather__bell-ring-animation': useBellRingAnimation}]"
    v-mouseover-class="{ overClass: mouseOverClass, outClass: null }"
    @click="$emit(appConstants.app.emitEvents.CLICK)"
  >
    <feather-icon
      :icon="icon"
      :size="size"
      :class="[{'app-feather__feather-custom-size': customizeSize}]"
    />
  </div>
</template>

<script>

import appConstants from '@/constants/constants'
import useApp from '@/composables/app'

export default {
  name: 'AppFeather',
  emits: ['click'],
  props: {
    icon: {
      type: String,
      required: true,
      validator: val => useApp().featherIconTypes.includes(val),
    },
    size: {
      type: [String, null],
      required: false,
      default: () => '18',
    },
    containerSize: {
      type: [Number, String, null],
      required: false,
    },
    useBellRingAnimation: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    customizeSize: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    mouseOverClass: {
      type: [String, null],
      required: false,
      default: () => null,
    },
  },
  setup() {
    return {
      appConstants,
    }
  }
}
</script>

<style lang='scss'>

.app-feather {
  display: flex;
  align-items: center;
  justify-content: center;

  &__feather-custom-size {
    width: auto !important;
    height: auto !important;
  }

  &__bell-ring-animation {
    &:hover {
      animation: bell-ring 1s ease-in-out infinite;
      transform-origin: center center;
    }

    @keyframes bell-ring {
      0% { transform: rotate(0deg); }
      10% { transform: rotate(15deg); }
      20% { transform: rotate(-15deg); }
      30% { transform: rotate(10deg); }
      40% { transform: rotate(-10deg); }
      50% { transform: rotate(5deg); }
      60% { transform: rotate(-5deg); }
      70% { transform: rotate(2deg); }
      80% { transform: rotate(-2deg); }
      90% { transform: rotate(1deg); }
      100% { transform: rotate(0deg); }
    }
  }
}

</style>
